import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { FantasyLeaderboardStore, FantasyLeaderboardState } from './fantasy-leaderboard.store';

@Injectable({ providedIn: 'root' })
export class FantasyLeaderboardQuery extends Query<FantasyLeaderboardState> {

  constructor(protected store: FantasyLeaderboardStore) {
    super(store);
  }

  getMonthlyLeaderboard() {
    return this.getValue().monthlyLeaderboard;
  }

  getYearlyLeaderboard() {
    return this.getValue().yearlyLeaderboard;
  }
}
